module Meevo.Plugins.Register {
    "use strict";

    export class ClientAccountPaymentsSection extends Meevo.Plugins.Register.RegisterPaymentSectionBase {
        payment: Model.SaleClientAccountPayment;
        client: Model.ClientListItem;
        balance: number = 0;
        originalBalance: number = 0;
        allowChargesCreditOnAccount: boolean = false;
        accountSpendingLimit: number;
        remainingAvailableCredit: number;
        
        get $translate() { return this.registerContext.$translate; }

        get dataService() { return this.registerContext.dataService; }
        get modalService() { return this.registerContext.modalService; }
        get registerClientAccountService() { return this.registerContext.registerClientAccountService; }

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.ClientAccountPayment, registerContext, "clientAccountPayments", Register.RegisterSectionCatTypeEnum.Payment);
        }

        addPayment() {
            if (!this.client) {
                return;
            }

            if (!this.allowChargesCreditOnAccount) {
                this.modalService.alert('LABEL_CLIENT_ACCOUNT_NOT_ENABLED');
                return;
            }

            if (this.registerContext.isCreditMode) {
                let changeDue = this.registerContext.getChangeDue();
                let currentBalance = this.balance;

                this.registerClientAccountService.generateClientAccountSaleLines(
                    this.registerContext.sale, 
                    this.client, 
                    changeDue, 
                    currentBalance, 
                    this.registerContext.HouseEmployee
                );

                this.registerContext.recalculateSale().then(() => {
                    this.reset();

                    if (this.registerContext.isCreditMode) {
                        this.registerContext.finishSection();
                        return;
                    }

                    this.selectSectionPostAdd();
                });
            } else {
                if (this.remainingAvailableCredit < 0) {
                    this.modalService.alert("MESSAGE_EXCEED_ACCOUNT_SPENDING_LIMIT");
                    return;
                }

                this.payment.clientId = this.client.id;
                this.payment.clientDisplayName = this.client.displayName;
    
                super.addPayment();
            }
        }

        amountChanged() {
            this.recalculateRemaingAvailableCredit();
        }

        reset() {
            this.client = this.registerContext.selectedClientType == Model.ClientTypeEnum.Client 
                ? this.registerContext.selectedClient 
                : undefined;
            
            let paymentType = _.findWhere(this.registerContext.paymentTypes, { 
                paymentCategory: Model.PaymentCategoryEnum.ClientAccount, 
                paymentSubCategory: Model.PaymentSubCategoryEnum.AccountCharge 
            });
            
            this.payment = {
                __type: "Millennium.Meevo.Register.Contracts.Model.SalePaymentClientAccount, Millennium.Meevo.Register.Contracts.Model",
                paymentTypeId: paymentType.id,
                amount: 0,
                paymentCategory: Model.PaymentCategoryEnum.ClientAccount,
                paymentSubCategory: Model.PaymentSubCategoryEnum.AccountCharge,
                clientId: this.client ? this.client.id : null,
                clientDisplayName: this.client ? this.client.displayName : null,
            };
            this.getBalance();
        }

        clientChanged() {
            this.getBalance();
        }

        getBalance() {
            if (this.client) {
                let clientAccountCharges = _(this.registerContext.sale.paymentLines)
                    .chain()
                    .where({
                        paymentCategory: Model.PaymentCategoryEnum.ClientAccount,
                        clientId: this.client.id,
                    })
                    .reduce((total, payment) => {
                        return total + payment.amount;
                    }, 0)
                    .value();

                this.dataService.customMethodData(`api/client/${this.client.id}/accountbalance`, "get", {}, {includeSpendingLimit:true}).then((response: any) => {
                    this.originalBalance = this.registerContext.normalizeDecimalPlaces(+response.data.accountBalance);
                    this.balance = +response.data.accountBalance;
                    this.allowChargesCreditOnAccount = response.data.allowChargesCreditOnAccount;
                    this.accountSpendingLimit = response.data.accountSpendingLimit;
                    this.getClientAccountSaleLinesForClient(this.client.id, (saleLine) => {
                        this.balance += +saleLine.baseItemPrice;
                    });
                    this.balance -= clientAccountCharges;
                    this.balance = this.registerContext.normalizeDecimalPlaces(this.balance);
                    this.recalculateRemaingAvailableCredit();
                });
            }
        }

        recalculateRemaingAvailableCredit() {
            this.remainingAvailableCredit = angular.isDefined(this.accountSpendingLimit) ?
                this.registerContext.roundingService.addNormalizedNumbersSpread(
                    this.accountSpendingLimit, this.balance, -this.payment.amount) : 0;
        }

        getClientAccountSaleLinesForClient(clientId, matchingSaleLineAction = undefined) {
            let matchingSaleLines = [];
            this.registerContext.sale.saleLines.forEach((saleLine) => {
                if ((saleLine.saleType === Model.SalesTypeEnum.ClientAccountCredit || saleLine.saleType === Model.SalesTypeEnum.ClientAccountPayment) && (<ClientAccountSaleLineItem>saleLine.item).id == clientId) {
                    matchingSaleLines.push(saleLine);
                    if (matchingSaleLineAction) {
                        matchingSaleLineAction(saleLine);
                    }
                }
            });
            return matchingSaleLines;
        }

        hasItems() {
            return _(this.registerContext.allUniqueClients).any((item: any) => item.client && item.client.allowChargesCreditOnAccount && item.client.accountBalance > 0);
        }        
    }
}